<template>
  <div
    v-if="campaign.report && campaign.member"
    class="row"
  >
    <div class="col-20 upper-std-wrapper-title">
      {{ $t('view-CampaignsCpcDetails.Report.title') }}
    </div>
    <div class="col-20 std-wrapper mt-0 p-3 px-4 pt-4">
      <div class="row">
        <div class="col-20 col-md-10">
          <data-display
            :title="$t('view-CampaignsCpcDetails.Report.Influencer.legend.correct')"
            class="mb-4 d-block"
          >
            {{ campaign.report.correct_links_count || 0 }}
          </data-display>
          <small class="d-block mb-3">
            {{ $t('view-CampaignsCpcDetails.Report.Influencer.pay_info') }} <strong>10 {{ $currencySymbol(campaign.currency) }}</strong>.<br>
            {{ $t('view-CampaignsCpcDetails.Report.Influencer.pay_info2') }} <strong>1 {{ $currencySymbol(campaign.currency) }}</strong>.
          </small>
        </div>
        <div class="col-20 col-md-8 offset-md-2">
          <data-display
            v-if="campaign.status !== 'canceled'"
            :title="$t('view-CampaignsCpcDetails.Report.Influencer.legend.to_pay')"
            class="mb-4 d-block"
          >
            {{ campaign.report.value_to_pay || 0 }} {{ $currencySymbol(campaign.currency) }}
          </data-display>
          <data-display
            v-else
            :title="$t('view-CampaignsCpcDetails.Report.Influencer.legend.lost')"
            class="mb-4 d-block"
          >
            {{ campaign.report.value_to_pay || 0 }} {{ $currencySymbol(campaign.currency) }}
          </data-display>
          <data-display
            :title="$t('view-CampaignsCpcDetails.Report.Influencer.legend.payed')"
            class="mb-4 d-block"
          >
            {{ campaign.report.payed_value || 0 }} {{ $currencySymbol(campaign.currency) }}
          </data-display>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleDataDisplay from '../../../components/SimpleDataDisplay.vue'

export default {
  components: {
    'data-display': SimpleDataDisplay
  },
  props: {
    campaign: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {

  }
}
</script>

<style lang="scss" scoped>

</style>
